import React from "react";
import { useTranslations } from "next-intl";
const Header = () => {
  const t = useTranslations("aboutUs");
  return (
    <div>
      <div className="max-w-[90rem] responsive m-auto" id="vision">
        <p className="mt-[41px] mb-[41px] text-[#010140] text-[18px] leading-[26px] font-normal	">
          {t("title")}
        </p>
      </div>
      <div className="relative max-w-[90rem] m-auto w-[80%]">
        <div className="absolute  ">
          <h2 className="  leading-[32px] text-[25px] font-semibold mds:text-[48px] mds:leading-[64px] w-[100%] text-[#010140]	max-w-[607px] whitespace-nowrap ">
            {t("ourvision")}
          </h2>
          <p className=" leading-[32px] text-[26px] font-semibold mds:text-[48px] mds:leading-[64px] w-[100%] text-[#010140]	max-w-[607px] mt-[10px] ">
            {t("ourvision2")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Header;
5;
